import { SortDescriptor } from 'react-stately';

export const SortDescriptorToApiParam = (sortDescriptor: SortDescriptor) =>
  `${sortDescriptor.direction === 'descending' ? '-' : ''}${sortDescriptor.column}`;
